import { getKeys } from './getKeys'

export const carePlansTranslations = {
  ERROR_FLUID_TARGET_CAN_NOT_BE_EMPTY: 'Fluid target can not be empty',
  ERROR_INVALID_CHARACTER: 'Invalid character',
  ERROR_FLUID_TARGET_CAN_NOT_BE_0: 'Fluid target can not be 0',
  ERROR_CORRECT_AMOUNT: 'Make sure you have typed the correct amount',
  FLUID_TRACKING: 'Fluid tracking',
  DISABLE: 'Disable',
  ENABLE: 'Enable',
  FIND_OUT_MORE: 'Find out more',
  DAILY_INTAKE_TARGET: 'Daily intake target',
  SELECT_NEEDS: 'Select Needs',
  CHOOSE_FORM_LIST: 'Choose from list',
  NO_CURRENT_TARGET: 'No current target',
  DAILY_INTAKE_TARGET_ML: 'Daily intake target of {{intakeTarget}}ml',

  //ResidentCarePlansDashboardScreen
  REVIEWED: 'Reviewed',
  CREATED: 'Created',
  NO_REVIEWS_YET: 'No reviews yet',
  CARE_PLAN: 'Care Plan',
  DOWNLOAD_PDF: 'Download PDF',
  PDF: 'PDF',
  ADD: 'Add',
  SORT_BY: 'Sort by:',
  NO_FURTHER_SUPPORT_REQUIRED: 'No Further Support Required',
  NEXT_REVIEW_NO_DATE_SET: 'No date set',
  NEXT_REVIEW: 'Next review',
  NOTHING_TO_SEE_HERE: 'Nothing to see here!',
  FINALISE_INITIAL_ASSESSMENT:
    "Finalise {{name}}'s Initial Assessment for this {{carePlanNominative}}",
  FINALISE_INITIAL_ASSESSMENT_DESCRIPTION:
    "When you finalise the Initial Assessment for this {{preferredPeopleNominative}},  you'll be able to create their {{carePlanNominative}}",
  RESIDENT: 'resident',
  BLANK_STATE_DESCRIPTION_ADLS:
    "{{carePlanNominative}} will appear here if they have been reviewed as having 'No Further Support Required'.",

  // Needs Section (mods_needs_care_plan)
  NEEDS_SECTION_TITLE: 'Needs',
  ADD_NEEDS_BUTTON: 'Add needs',
  NEEDS_MODAL_TITLE: 'Adding needs',
  NEEDS_MODAL_CONFIRM: 'Add',
  NEEDS_MODAL_CANCEL: 'Cancel',
  NEEDS_MODAL_FIELD_LABEL: 'Needs',
  NEEDS_MODAL_HELPER_TEXT: 'Choose all needs for this {{carePlanNominative}}.',
  NEEDS_MODAL_PLACEHOLDER: 'Choose needs',
  NEEDS_MODAL_ERROR_EMPTY:
    'Choose all relevant needs for this {{carePlanNominative}}.',
  NEEDS_MODAL_ERROR_DUPLICATE:
    'This need has already been added to the {{carePlanNominative}}.',
  NEED_CREATED_BY: 'Created {{date}} by {{name}}',
  NEED_UPDATED_BY: 'Last updated {{date}} by {{name}}',
  NEED_LAST_REVIEW: 'Last review {{date}}',
  NEED_UPDATED_BADGE: 'Updated',
  NEED_UPDATED_WARNING: 'This need has been updated since last review',
  NEED_SHOW_NOTES: 'Show notes',
  NEED_HIDE_NOTES: 'Hide notes',
  NEED_REMOVE_ACTION: 'Remove need',
  NEEDS_NO_SNAPSHOT: 'No needs were linked at the time of this review',
  LEGACY_NEED_UNAVAILABLE: 'Need unavailable',
  NEEDS_ADDED_TOAST: 'Needs added!',
  NEED_REMOVED_TOAST: 'Need removed!',
  REMOVE_NEED_MODAL_TITLE: 'Removing need',
  REMOVE_NEED_MODAL_CONFIRM: 'Remove',
  REMOVE_NEED_MODAL_CANCEL: 'Cancel',
  REMOVE_NEED_MODAL_BODY: 'Are you sure you want to remove this need?',

  // Suggested needs (initial_assessments_needs_suggestions_review).
  // Prototype-literal UI; decisions are staged locally and only committed
  // when the review is saved (per the design's save/cancel scenario notes).
  SUGGESTED_NEEDS_TITLE: 'Suggested needs',
  SUGGESTED_NEEDS_AI_BETA: 'Beta',
  SUGGESTED_NEEDS_EXPLAINER:
    "These needs were mentioned in {{name}}'s initial assessments.",
  SUGGESTED_NEEDS_LIST_ARIA: 'Suggested needs to review',
  SUGGESTED_NEEDS_DONT_SHOW: "Don't show this again",
  SUGGESTED_NEEDS_REMOVED_TOAST: 'Suggested needs removed',
  /** Fallback when the home has no preferred care-plans nominative set. */
  CARE_PLANS_NOMINATIVE_DEFAULT: 'care plans',
  REMOVE_SUGGESTIONS_MODAL_TITLE: 'Removing suggested needs',
  REMOVE_SUGGESTIONS_MODAL_BODY:
    'Once you confirm, these suggestions will no longer be shown for {{name}}.',
  REMOVE_SUGGESTIONS_MODAL_QUESTION: 'Are you sure you want to remove this?',
  REMOVE_SUGGESTIONS_MODAL_CONFIRM: 'Remove',
  REMOVE_SUGGESTIONS_MODAL_CANCEL: 'Cancel',
  REMOVE_SUGGESTIONS_ERROR:
    "The suggestions couldn't be removed. Please try again.",
  SUGGESTED_NEEDS_DISCLAIMER:
    'AI can make mistakes. Review and verify all responses and results.',
  SUGGESTED_NEEDS_SHOW_ALL: 'Show all suggestions',
  SUGGESTED_NEEDS_SHOW_LESS: 'Show less suggestions',
  SUGGESTED_NEED_REVIEW_ARIA: 'Review suggestion: {{need}}',
  SUGGESTED_NEED_USE: 'Use this need',
  SUGGESTED_NEED_USE_ARIA: 'Use this need: {{need}}',
  SUGGESTED_NEED_ADDED: 'Need added',
  SUGGESTED_NEED_ADDED_TO: "Added to {{name}}'s {{carePlans}}.",
  SUGGESTED_NEEDS_LOAD_ERROR: "Suggestions couldn't be loaded.",
  SUGGESTED_NEEDS_RETRY: 'Try again',
  SUGGESTED_NEEDS_COMMIT_ERROR:
    "Your suggestion decisions couldn't be applied, so the review has not been saved. Please try again.",
  SUGGESTED_NEED_AI_ASSISTED: 'AI-assisted',
  SUGGESTED_NEED_ANNOUNCE_ADD: "{{need}} added to {{name}}'s care plan",

  // Consent Section
  CONSENT_SECTION_TITLE: 'Consent',
  CONSENT_SECTION_DESCRIPTION:
    'Link consent forms here or manage all consent forms in',
  CONSENT_SECTION_DESCRIPTION_VIEW:
    'Link consent forms by reviewing this care plan, or manage all consent forms in',
  CONSENT_MANAGEMENT_LINK: 'Consent management',
  LINK_CONSENT_BUTTON: 'Link Consent',
  CONSENT_MODAL_TITLE: 'Select from available Consent forms',
  CONSENT_MODAL_PLACEHOLDER: 'Select consent form to link',
  CONSENT_MODAL_CONFIRM: 'Confirm',
  CONSENT_MODAL_CANCEL: 'Cancel',
  CONSENT_SIGNED_ON: 'Signed on {{date}} - {{createdBy}}',
  CONSENT_CREATED_ON: 'Created on {{date}} - {{createdBy}}',
  CONSENT_REFUSED: 'Refused consent',

  // Consent Form Item
  CONSENT_FORM_CREATED_DATE: 'Created on {{date}} - {{createdBy}}',
  CONSENT_FORM_SIGNED_DATE: 'Signed on {{date}} - {{signedBy}}',
  CONSENT_STATUS_COMPLETED: 'Completed',
  CONSENT_STATUS_PENDING: 'Pending',
  CONSENT_STATUS_REQUESTED: 'Requested',
  CONSENT_STATUS_REFUSED: 'Refused',
  CONSENT_STATUS_WITHDRAWN: 'Withdrawn',
  CONSENT_STATUS_PLANNED: 'Planned',
  CONSENT_STATUS_SCHEDULED: 'Scheduled',
  CONSENT_STATUS_POSTPONED: 'Postponed',
  CONSENT_STATUS_CANCELLED: 'Cancelled',
  CONSENT_STATUS_PROVIDED: 'Provided',

  // History
  UNKNOWN_TEAM_MEMBER: 'Unknown team member',

  // End of Life Sections
  EOL_ADD_SECTION: 'Add section',
  EOL_ADD_SECTION_SUBTITLE: 'Select a section type to add above Documents.',
  EOL_ADD_NEW_SECTION: 'Add new section',
  EOL_SAVE_SECTION: 'Save section',
  EOL_UPDATE_SECTION: 'Update section',
  EOL_CANCEL: 'Cancel',
  EOL_BACK_TO_SECTION_TYPES: 'Back to section types',
  EOL_SECTION_TITLE_LABEL: 'Section title',
  EOL_SECTION_TITLE_PLACEHOLDER: 'Enter a title for this section',
  EOL_EDIT: 'Edit',
  EOL_REMOVE: 'Remove',
  EOL_REMOVE_SECTION_CONFIRM_TITLE: 'Remove section',
  EOL_REMOVE_SECTION_CONFIRM_BODY:
    'This will remove this section from the care plan. This cannot be undone after you save the review.',
  EOL_REMOVE_SECTION_CONFIRM_OK: 'Remove',
  EOL_REMOVE_SECTION_CONFIRM_CANCEL: 'Cancel',
  EOL_ACTION_LABEL: 'Action {{number}}'
}

export const carePlansConstants = getKeys(carePlansTranslations)
